var path = '/pages/exports/views/base-view.tpl.html';
var html = "<section>\n    <div class=\"content-box\">\n        <div class=\"box-section-wrap\">\n            <div class=\"form-group\"  ng-repeat=\"entry in vm.currentSideNavActions track by $index\">\n                <label>{{entry.label}}</label>\n                <p><small ng-if=\"entry.description\">{{entry.description}}</small></p>\n                <button class=\"btn btn-regular\" ng-click=\"vm.activateView(entry)\">\n                    Go to export\n                </button>\n            </div>\n        </div>\n    </div>\n</section>";
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
module.exports = path;


//////////////////
// WEBPACK FOOTER
// ./src/app/pages/exports/views/base-view.tpl.html
// module id = 2247
// module chunks = 1